import $api from '@/apiProvider'
import UploadList from '@/components/common/UploadList'
import BankAccount from '@/components/modal/BankAccount'
import Account from '@/components/modal/Account'
import PlatformCorp from '@/components/common/PlatformCorp'
import CustomerSelect from '@/components/common/CustomerSelect'
import SalesMan from '@/components/common/SalesMan'
import getAuthOrization from "@/mixin/getAuthOrization";
import {
    orderDetail,
    showLoading,
    hideLoading,
    isNotEmpty
} from '@/utils/util'
import {
    isEmpty
} from "xe-utils/methods";
import AboutPaymentOrder from "@/components/order/AboutPaymentOrder";
const assign = (val) => Object.assign({}, val)
const empties = [undefined, '', null, 'null', {},
    [], '[]'
]

export default {
    mixins: [getAuthOrization],
    name: 'PaymentDetail',
    components: {
        PlatformCorp,
        CustomerSelect,
        SalesMan,
        ChooseOrder: AboutPaymentOrder,
        BankAccount,
        UploadList,
        ChooseAccount: Account
    },
    props: {
        cate: {
            type: String,
            default: ''
        },
        isShow: {
            type: Boolean,
            default: false
        },
        chainId: Number
    },
    data() {
        return {
            queryAction: '',
            updateAction: '',

            paymentId: 0,

            isShowChooseOrder: false,
            amountListName: '',
            isShowChooseAccount: false,
            isShowBankAccountModal: false,

            isEdit: false,
            ordersList: [], //关联的订单数据
            orderTmp: {
                "id": null,
                "ordersId": null,
                "aboutAmount": null,
                "buyerName": null,
                "chainNum": null,
                "compName": null,
                "ordersNumb": null,
                "sellerName": null,
            },
            row: {},
            tableData: [], //详情收付款数据 只有一条
            editRules: {
                payAmount: [{
                    validator: this.requireValid
                }],
                salesMan: [{
                    validator: this.requireValid
                }],
                addTime: [{
                    validator: this.requireValid
                }],
                note: [{
                    validator: this.requireValid
                }],
                paymentsName: [{
                    validator: this.requireValid
                }],
                recName: [{
                    validator: this.requireValid
                }]
            },
            aboutOrderList: [],
            selectTab: 'tab1',
            usedAmount: null,
            page: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 100,
            },
            allAboutOrderList: [],
            formData:{
                compName: null,
                salesMan: null,
                clientName: null,
                addTime: null,
                note: null,
                payBankCode: null,
                payAmount: null,
                usedAmount: null,
                unusedAmount: null,
                paymentsName: null,
                payBank: null,
                payAccount: null,
                recName: null,
                recBank: null,
                recAccount: null
              }
        };
    },
    watch: {
        isShow: {
            deep: true,
            immediate: true,
            handler: function (newVal, oldVal) {
                //关闭弹窗
                if (newVal == false && oldVal == true) {
                    this.isEdit = false
                    this.selectTab = 'tab1'
                    this.aboutOrderList = [];
                    this.page.totalResult = 0;
                    this.page.pageSize = 10;
                    this.page.currentPage = 1;
                    this.usedAmount = null;
                    // this.clearValidate()
                }
            }
        },
        cate: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                switch (this.cate) {
                    case 'Collection':
                        this.amountListName = 'ordersBuyerAmountList'
                        this.queryAction = 'queryPaymentsBuyerDetail'
                        this.updateAction = 'updatePaymentsBuyer'
                        break
                    case 'Payment':
                        this.amountListName = 'ordersSellerAmountList'
                        this.queryAction = 'queryPaymentsSellerDetail'
                        this.updateAction = 'updatePaymentsSeller'
                        break
                    case 'SellerPayment':
                        this.amountListName = 'ordersSellerLv2sAmountList'
                        // this.queryAction = 'queryPaymentsSellerLv2Detail' // 此接口作废
                        this.queryAction = 'queryPaymentsSellerDetail'
                        this.updateAction = 'updatePaymentsSellerLv2'
                        break
                }
            }
        },
    },
    methods: {
        async init(paymentId, paymentCate) {
            // 第一次点击BUG
            if (paymentCate === 'Payment') {
                this.amountListName = 'ordersSellerAmountList'
                this.queryAction = 'queryPaymentsSellerDetail'
                this.updateAction = 'updatePaymentsSeller'
            } else if (paymentCate === 'SellerPayment') {
                this.amountListName = 'ordersSellerLv2sAmountList'
                this.queryAction = 'queryPaymentsSellerLv2Detail'
                this.updateAction = 'updatePaymentsSellerLv2'
            }
            this.paymentId = paymentId;
            this.getData()
        },
        checkTab(val) {
            this.selectTab = val
        },
        setEdit(isEdit) {
            this.isEdit = isEdit
        },
        async getData() {
            let res = await $api.payments.request(this.queryAction, {
                id: this.paymentId
            })
            if (res.status == 1) {
                let row = res.data
                // this.orderTmp.aboutAmount = row.payAmount
                // console.log(row, 'aaaaaaa');
                //详情数据从详情接口去取
                if (row.addTime != null) {
                    row.addTime = this.$utils.toDateString(row.addTime, 'yyyy-MM-dd')
                }
                if (row.createTime != null) {
                    row.createTime = this.$utils.toDateString(row.createTime, 'yyyy-MM-dd')
                }
                if (empties.includes(row.ordersList) || row.ordersList.length == 0) {
                    this.ordersList = [assign(this.orderTmp)]
                } else {
                    this.ordersList = row.ordersList.filter(item => item.id == this.paymentId)
                    this.usedAmount = row.ordersList.reduce((prev, cur) => {
                        return Math.round(cur.aboutAmount * 100) / 100 + prev
                    }, 0);
                    this.usedAmount = Math.round(this.usedAmount * 100)/ 100
                    this.page.totalResult = row.ordersList.length;
                    this.allAboutOrderList = row.ordersList;
                    this.aboutOrderList = row.ordersList.slice(0, this.page.pageSize)
                    row[this.amountListName] = row.ordersList
                    row.clientName = this.ordersList.length === 1 ? this.ordersList[0].clientName : row.clientName
                }
                row.unusedAmount = parseFloat(row.unusedAmount).toFixed(2)
                // 有关联订单时取关联订单客户  没有时取原本客户
                
                this.row = row
                this.tableData = [row]
                this.formData = row
                // console.log(this.tableData, 'rowwwww');
                // debugger
                if (isEmpty(row.fileList) && undefined != this.$refs.uploadList) {
                    this.$refs.uploadList.init([])
                }
            } else {
                if (empties.includes(res.message)) {
                    res.message = '接口异常'
                }
                this.$XModal.message({
                    status: 'error',
                    message: res.message
                })
            }
        },
        handlePageChange({
            currentPage,
            pageSize
        }) {
            // 分页
            this.page.currentPage = currentPage;
            this.page.pageSize = pageSize;
            this.aboutOrderList = this.allAboutOrderList.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        },
        clearValidate() {
            this.$refs.t1.clearValidate()
            this.$refs.t2.clearValidate()
        },
        async requireValid(e) {
            if ([undefined, '', null, 'null', {},
                    []
                ].includes(e.cellValue)) {
                return Promise.reject(new Error(e.column.title + '必填'))
            }
        },
        inputPayAmountEvent(row) {
            if (!empties.includes(row.payAmount) && row.orderNum == ' ') {
                row.orderNum = null
            }
            //修改已关联订单的关联金额
            if (isNotEmpty(row[this.amountListName])) {
                row[this.amountListName][0].aboutAmount = row.payAmount
                row.usedAmount = row.payAmount
            }

            this.$refs.t2.clearValidate()
        },
        async validEvent() {
            const errMap1 = await this.$refs.t1.validate().catch((errMap1) => errMap1);
            if (errMap1) return false
            const errMap2 = await this.$refs.t2.validate().catch((errMap2) => errMap2);
            if (errMap2) return false
            return true
        },
        editEvent() {
            this.isEdit = true
        },
        async cellClick(e) {
            let row = e.row
            let field = e.column.property
            if (this.isEdit) {
                if (field == 'ordersNumb') {
                    this.openOrderModal()
                }
            } else {
                if (field == 'chainNum' && !empties.includes(row.chainId)) {
                    orderDetail(this, 0, row.chainId)
                } else if (field == 'ordersNumb' && !empties.includes('ordersNumb')) {
                    if (this.cate == 'Collection' && !empties.includes(row.ordersId)) {
                        orderDetail(this, 1, row.ordersId)
                    } else if (this.cate != 'Collection' && !empties.includes(row.ordersId)) {
                        orderDetail(this, 2, row.ordersId)
                    }
                }
            }
        },
        footerMethod({
            columns,
            data
        }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return "单页合计";
                    }
                    if (["aboutAmount"].includes(column.property)) {
                        return this.$utils.sum(data, column.property);
                    }
                    return null;
                }),
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return "全部合计";
                    }
                    if (["aboutAmount"].includes(column.property)) {
                        return this.usedAmount;
                    }
                    return null;
                }),
            ];
        },
        async selectCompName(row, id, name) {
            if (isNotEmpty(row.compName) && row.compName != name && isNotEmpty(row[this.amountListName])) {
                let confirmRes = await this.$XModal.confirm(
                    "更换所属平台公司将清空关联订单",
                    "是否更换"
                );
                if (confirmRes === "confirm") {
                    row[this.amountListName] = []
                    this.ordersList = [assign(this.orderTmp)]
                } else {
                    return
                }
            }
            row.platformCompanyId = id
            row.compName = name
        },
        openChooseAccount(row, field) {
            this.isShowChooseAccount = true
            this.currentRow = row
            this.currentChooseColumn = field
            this.$refs.chooseAccount.init()
        },
        chooseAccountEvent(account, type) {
            console.log('chooseAccountEvent', account)
            this.currentRow[this.currentChooseColumn] = account.userName
            this.isShowChooseAccount = false
            this.$refs.t2.clearValidate(this.currentChooseColumn)
        },
        async openOrderModal() {
            if (!this.isEdit) return this.needEdit()
            //注意 点击关联订单的一行 实际要操作的数据却是 收付款的数据
            let row = this.tableData[0]
            if (empties.includes(row.payAmount)) {
                await this.$refs.t1.clearValidate()
                await this.$refs.t2.clearValidate()
                await this.$refs.t2.validate()
            } else {
                this.currentChooseColumn = this.amountListName
                this.currentRow = row
                this.isShowChooseOrder = true
                //付款明细 不用根据公司筛选
                this.$refs.refPaymentAboutOrder.init(this.cate, null, 0, this.ordersList, null)
            }
        },
        chooseOrderEvent(ordersList, usedAmount) {
            let oldOrderlist = this.currentRow[this.amountListName]
            var oldOrdersMap = {}
            //已经关联订单列表
            if (!empties.includes(oldOrderlist)) {
                oldOrderlist.forEach(item => {
                    oldOrdersMap[item.ordersId] = item.id
                })
            }
            //新选择订单列表
            if (ordersList.length > 0) {
                ordersList.forEach(item => {
                    // console.log(item, '1111');
                    // debugger
                    if (empties.includes(oldOrdersMap[item.id])) {
                        item.id = null
                    } else {
                        item.id = oldOrdersMap[item.id]
                    }
                    if (this.cate == 'Collection') {
                        item.compName = item.sellerName
                    } else if (this.cate == 'Payment') {
                        item.compName = item.buyerName
                    } else {
                        //buyerName compName sellerName sellerLv2Name 
                        item.sellerLv2Name = item.sellerName
                        item.sellerName = item.buyerName
                        item.compName = ''
                        item.buyerName = ''
                    }
                    //付款关联金额使用 付款信息的金额
                    if (this.cate != "Collection") {
                        item.aboutAmount = this.currentRow.payAmount
                        //所属公司-compName  业务员-salesMan  客户名称-clientName
                        this.currentRow.platformCompanyId = item.platformCompanyId
                        this.currentRow.platformCompanyName = item.platformCompany
                        this.currentRow.salesMan = item.salesManName
                        this.currentRow.salesManId = item.salesMan
                        if (this.cate === "SellerPayment") {
                            this.currentRow.clientName = item.sellerLv2Name
                        } else {
                            this.currentRow.clientName = item.sellerName
                        }
                    }
                });
            } else {
                ordersList = [assign(this.orderTmp)]
            }
            console.log(this.currentRow, ordersList[0])
            this.currentRow[this.amountListName] = ordersList
            this.currentRow.usedAmount = usedAmount
            this.ordersList = ordersList
            this.isShowChooseOrder = false
            this.clearValidate()
        },
        openBankAccountModal(row, field, accountCate) {
            if (!this.isEdit) return this.needEdit()
            this.currentRow = row
            this.currentChooseColumn = field
            console.log(field)
            this.isShowBankAccountModal = true
            this.$refs.bankAccountModal.init(accountCate, field, row)
        },
        chooseBankAccount(bankAccount) {
            console.log('chooseBankAccount', this.currentChooseColumn, bankAccount)
            if (this.currentChooseColumn == 'paymentsName') {
                this.currentRow.paymentsName = bankAccount.accountName
                this.currentRow.payBank = bankAccount.bankName
                this.currentRow.payAccount = bankAccount.accountNum
            } else {
                this.currentRow.recName = bankAccount.accountName
                this.currentRow.recBank = bankAccount.bankName
                this.currentRow.recAccount = bankAccount.accountNum
            }
            this.isShowBankAccountModal = false
            this.$refs.t2.clearValidate(this.currentChooseColumn)
        },
        insertOrder() {
            if (!this.isEdit) return this.needEdit()
            this.$refs.t1.clearValidate()
            this.$refs.t1.insert(assign(this.orderTmp))
        },
        deleteOrder(row) {
            if (!this.isEdit) return this.needEdit()
            this.$refs.t1.remove(row)
        },

        async submitEvent() {
            let sts = await this.validEvent()
            if (!sts) {
                this.$XModal.message({
                    status: "error",
                    message: "校验不通过！"
                });
                return
            }

            let row = assign(this.tableData[0])

            row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime))

            row.usedAmount = 0
            if (this.ordersList.length == 1 && (this.ordersList[0].ordersId == null)) {
                row.ordersList = []
            } else {
                row.ordersList = this.ordersList
            }

            row.ordersList.forEach(order => {
                row.usedAmount += order.aboutAmount
            })
            row.unusedAmount = row.payAmount - row.usedAmount
            row[this.amountListName] = row.ordersList

            showLoading()
            let res = await $api.payments.request(this.updateAction, row)
            hideLoading()

            if (res.status == 1) {
                this.$XModal.message('提交成功')
                this.$emit('close')
                this.$emit('init')
            } else {
                if (!res.message) {
                    res.message = '接口异常'
                }
                this.$XModal.message(res.message)
            }
        },
        needEdit() {
            this.$XModal.message('编辑状态下才可操作')
        },
        spanMethod({
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 0) {
                if (rowIndex == 0) {
                    return {
                        rowspan: this.ordersList.length,
                        colspan: 1
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            } else {
                return {
                    rowspan: 1,
                    colspan: 1
                }
            }
        },
        authUpdate() {
            return this.cate == 'Collection' && this.isHavePermission('payments:updatePaymentsBuyer') ||
                this.cate == 'Payment' && this.isHavePermission('payments:updatePaymentsSeller') ||
                this.cate == 'SellerPayment' && this.isHavePermission('payments:updatePaymentsSellerLv2')
        },
    },
};